import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "home_top_bg" }
const _hoisted_3 = { class: "top_main" }
const _hoisted_4 = { class: "home_main mt64 team_box" }
const _hoisted_5 = { class: "team_left bg2" }
const _hoisted_6 = { class: "user_title" }
const _hoisted_7 = { class: "user_number" }
const _hoisted_8 = { class: "qualifications" }
const _hoisted_9 = { class: "carousel_box" }
const _hoisted_10 = { class: "carousel_content" }
const _hoisted_11 = { class: "item_img" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "item_title" }
const _hoisted_14 = { class: "tab_box" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "home_main mt64 zs_wrap" }
const _hoisted_17 = { class: "zs_box" }
const _hoisted_18 = ["src"]
const _hoisted_19 = { class: "contact mt64" }
const _hoisted_20 = { class: "contact_main" }
const _hoisted_21 = { class: "contact_wrap" }
const _hoisted_22 = { class: "wrap_box" }
const _hoisted_23 = { class: "wrap_right" }
const _hoisted_24 = { class: "feedback" }
const _hoisted_25 = { class: "feedback" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NCarousel = _resolveComponent("NCarousel")!
  const _component_NInput = _resolveComponent("NInput")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[6] || (_cache[6] = _createElementVNode("img", { src: "https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741933872032/home_top_bg.png" }, null, -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "top_btn",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleRouter && _ctx.handleRouter(...args)))
        }, _cache[5] || (_cache[5] = [
          _createElementVNode("span", null, "了解更多", -1),
          _createElementVNode("span", null, [
            _createElementVNode("img", {
              src: "https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741933955203/right.png",
              alt: ""
            })
          ], -1)
        ]))
      ])
    ]),
    _cache[17] || (_cache[17] = _createStaticVNode("<div class=\"home_main bg1 mt40 profile_box\" data-v-560e59b2><div class=\"profile_img\" data-v-560e59b2><img src=\"https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741933990106/home_main_img1.png\" data-v-560e59b2></div><div class=\"main_profile\" data-v-560e59b2><div class=\"profile_title\" data-v-560e59b2><span data-v-560e59b2>公司</span><span data-v-560e59b2>简介</span></div><div class=\"profile_translate\" data-v-560e59b2>Company Introduction</div><div class=\"profile_text\" data-v-560e59b2> 中致远工程管理咨询有限公司成立于2019年6月，位于四川省成都市金牛区高新技术产业园区，是西部地区的一家综合性工程咨询管理公司，是中国建设工程造价管理协会成员单位，四川省监理协会、中国招标投标协会等多家协会成员单位。 </div><div class=\"profile_text\" data-v-560e59b2> 公司具有建设部房屋建筑工程监理甲级资质、市政工程监理甲级资质，电力工程甲级资质，机电安装工程监理乙级资质，通信监理乙级资质等；水利工程施工监理乙级；地质灾害治理工程监理乙级等。 </div><div class=\"profile_text\" data-v-560e59b2> 目前核心业务为：全过程工程咨询服务、全过程造价咨询、招标与采购专业咨询、工程监理与运维专业咨询以及全过程BIM项目管理等，是集多项业务于一体的技术密集型发展中企业。 </div></div></div>", 1)),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teamList, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "team_user",
            key: index
          }, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(item.title), 1),
            _createElementVNode("div", _hoisted_7, [
              _createTextVNode(_toDisplayString(item.number) + " ", 1),
              _cache[7] || (_cache[7] = _createElementVNode("span", null, "人", -1))
            ])
          ]))
        }), 128))
      ]),
      _cache[8] || (_cache[8] = _createStaticVNode("<div class=\"team_right\" data-v-560e59b2><div class=\"team_item\" data-v-560e59b2><div class=\"team_text\" data-v-560e59b2> 公司管理团队具有良好的职业道德素养，专业技术精湛，管理经验丰富，已成功地为客户提供各类工程项目的专业技术服务，深受同行和客户的信任与尊重。公司人才荟萃、专业齐全，拥有一支长期从事工程造价、工程监理、招标代理、技术咨询的高素质专业人才队伍。 </div><div class=\"team_text\" data-v-560e59b2> 建设部批准的全国监理工程师33人，一级造价工程师13人，注册安全工程师1人，水利监理工程师9人，交通监理工程师10人，一级建造师、其他专业从业人员20余人，其中高级工程师13人，中级工程师28人，为工程咨询业务开展奠定了良好、坚实的人力资源基础。 </div></div><div class=\"team_item\" data-v-560e59b2><div class=\"team_text\" data-v-560e59b2> 公司成立至今，坚持精益求精、敬业诚信的经营服务理念，致力于为政府机构、行业用户和广大企事业单位提供全方位、全过程项目咨询服务。客户包括：四川省高级人民法院、成都市中级人民法院、攀枝花、德阳、内江、南充等多家地市级中级人民法院、广元市审计局、阿坝州审计局、巴中市住建局等多个地市级、县级人民政府、住建局、审计局、财政局，成都信息工程大学、成都大学等多所高等院校，国网四川省电力公司成都供电公司城西供电中心、成都市武侯社区商业投资发展有限责任公司、广东省电信规划设计院有限公司等多家企、事业单位，完成业主委托的各类咨询业务上千余项，投资额逾400多亿。 </div><div class=\"team_text\" data-v-560e59b2> 其中造价咨询项目：“若尔盖山水工程”全生命周期监测与适应性管理子项目、“6·10”马尔康地震灾后恢复重建2023年度跟踪审计第二阶段、三星堆浏阳路支线项目（一期工程）等；工程监理项目：九寨沟县柏悦丽豪酒店新建项目、炉霍县克木村生活垃圾高温热解建设项目监理服务等项目完成优良，为客户在投资、质量、进度、安全等方面做出了有效控制，受到客户和政府主管部门的好评。 </div></div></div>", 1))
    ]),
    _cache[18] || (_cache[18] = _createStaticVNode("<div class=\"home_main mt64 four_box\" data-v-560e59b2><div class=\"four_item\" data-v-560e59b2><div class=\"item_title\" data-v-560e59b2><div class=\"line\" data-v-560e59b2></div><div class=\"title\" data-v-560e59b2>经营原则</div></div><div class=\"item_text\" data-v-560e59b2> 公司正在建设以现代企业制度体系为基础的模式实施企业经营管理，内部组织机构健全、设置合理，以“简单、可行、可控、可操作”为总体经营原则 </div><div class=\"item_img\" data-v-560e59b2><img src=\"https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741934178018/four_icon1.png\" alt=\"\" data-v-560e59b2></div></div><div class=\"four_item\" data-v-560e59b2><div class=\"item_title\" data-v-560e59b2><div class=\"line\" data-v-560e59b2></div><div class=\"title\" data-v-560e59b2>管理制度体系</div></div><div class=\"item_text\" data-v-560e59b2> 公司建立和完善了一套行之有效的、规范化、标准化、精细化、程序化的管理制度体系。 </div><div class=\"item_img\" data-v-560e59b2><img src=\"https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741934222605/four_icon2.png\" alt=\"\" data-v-560e59b2></div></div><div class=\"four_item\" data-v-560e59b2><div class=\"item_title\" data-v-560e59b2><div class=\"line\" data-v-560e59b2></div><div class=\"title\" data-v-560e59b2>经营目标</div></div><div class=\"item_text\" data-v-560e59b2> 公司以“专业化服务领先、职业化管理领先”为经营目标。 </div><div class=\"item_img\" data-v-560e59b2><img src=\"https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741934246082/four_icon3.png\" alt=\"\" data-v-560e59b2></div></div><div class=\"four_item\" data-v-560e59b2><div class=\"item_title\" data-v-560e59b2><div class=\"line\" data-v-560e59b2></div><div class=\"title\" data-v-560e59b2>质量目标</div></div><div class=\"item_text\" data-v-560e59b2> 以“严格管理、优质服务、确保工程质量百分之百合格、服务承诺百分之百落实”为公司质量目标，高标准、高水平地为业主提供及时、全面的优质服务。 </div><div class=\"item_img\" data-v-560e59b2><img src=\"https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741934266051/four_icon4.png\" alt=\"\" data-v-560e59b2></div></div></div>", 1)),
    _createElementVNode("div", _hoisted_8, [
      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "qualifications_title" }, [
        _createElementVNode("span", null, "公司"),
        _createElementVNode("span", null, "资质")
      ], -1)),
      _cache[10] || (_cache[10] = _createElementVNode("div", { class: "qualifications_translate" }, "Qualification Certificate", -1)),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_NCarousel, {
            "show-arrow": "",
            autoplay: "",
            draggable: ""
          }, {
            dots: _withCtx(({ total, currentIndex, to }) => [
              _createElementVNode("div", _hoisted_14, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(total, (index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["tab_item", { ['active']: currentIndex === index - 1 }]),
                    key: index,
                    onClick: ($event: any) => (to(index - 1))
                  }, null, 10, _hoisted_15))
                }), 128))
              ])
            ]),
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.carouselList, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "carousel_item",
                  key: index,
                  style: _normalizeStyle('width:' + item.width + 'px')
                }, [
                  _createElementVNode("div", _hoisted_11, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.icon, (label, idx) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "img",
                        key: idx
                      }, [
                        _createElementVNode("img", {
                          src: label,
                          alt: ""
                        }, null, 8, _hoisted_12)
                      ]))
                    }), 128))
                  ]),
                  _createElementVNode("div", _hoisted_13, _toDisplayString(item.title), 1)
                ], 4))
              }), 128))
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _cache[11] || (_cache[11] = _createElementVNode("div", { class: "home_title" }, [
        _createElementVNode("span", null, "信用"),
        _createElementVNode("span", null, "证书")
      ], -1)),
      _cache[12] || (_cache[12] = _createElementVNode("div", { class: "home_translate" }, "Credit Certificate", -1)),
      _createElementVNode("div", _hoisted_17, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.certificateList, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["zs_item", item.isbtm ? 'zs_item_btm' : '']),
            key: index
          }, [
            _createElementVNode("img", {
              src: item.url,
              alt: ""
            }, null, 8, _hoisted_18)
          ], 2))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _cache[15] || (_cache[15] = _createElementVNode("div", { class: "contact_title" }, [
            _createElementVNode("span", null, "联系"),
            _createElementVNode("span", null, "我们")
          ], -1)),
          _cache[16] || (_cache[16] = _createElementVNode("div", { class: "contact_translate" }, "Contact Us", -1)),
          _createElementVNode("div", _hoisted_22, [
            _cache[14] || (_cache[14] = _createElementVNode("div", { class: "wrap_left" }, [
              _createElementVNode("div", { class: "contact_item" }, [
                _createElementVNode("div", null, "公司地址"),
                _createElementVNode("div", null, "成都市金牛区金科南路169号1栋10层1016号")
              ]),
              _createElementVNode("div", { class: "contact_item" }, [
                _createElementVNode("div", null, "联系电话"),
                _createElementVNode("div", null, "028-61666051")
              ])
            ], -1)),
            _createElementVNode("div", _hoisted_23, [
              _cache[13] || (_cache[13] = _createElementVNode("div", { class: "right_title" }, "留下您的联系方式", -1)),
              _createElementVNode("div", _hoisted_24, [
                _createVNode(_component_NInput, {
                  value: _ctx.name,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.name) = $event)),
                  type: "text",
                  style: {"width":"200px"},
                  placeholder: "输入您的姓名"
                }, null, 8, ["value"]),
                _createVNode(_component_NInput, {
                  value: _ctx.phone,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.phone) = $event)),
                  type: "text",
                  style: {"width":"200px","margin-left":"16px"},
                  placeholder: "输入您的联系电话"
                }, null, 8, ["value"])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _createVNode(_component_NInput, {
                  value: _ctx.content,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.content) = $event)),
                  placeholder: "简要说明您想资讯的内容",
                  type: "textarea",
                  style: {"width":"416px"},
                  autosize: {
                    minRows: 3,
                    maxRows: 5,
                  }
                }, null, 8, ["value"])
              ]),
              _createElementVNode("div", {
                class: "feedback_btn",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)))
              }, "发送")
            ])
          ])
        ])
      ])
    ])
  ]))
}